import { useBlinkContextWithValidation, } from '@thoughtspot/blink-context';
import { useEffect } from 'react';
const ADMIN_NAV_SERVICE_CONTRACT = [
    { propName: 'readClientQueryParamsFromPath', propType: 'function' },
    { propName: 'goToPath', propType: 'function' },
];
export const useBlinkContextForAdmin = () => {
    const [validate, blinkContext] = useBlinkContextWithValidation({
        navServiceContract: ADMIN_NAV_SERVICE_CONTRACT,
    });
    return blinkContext;
};
export const useValidateBlinkContextForAdmin = () => {
    const [validate, blinkContext] = useBlinkContextWithValidation({
        navServiceContract: ADMIN_NAV_SERVICE_CONTRACT,
    });
    useEffect(() => {
        validate('ADMIN');
    }, [validate]);
};
//# sourceMappingURL=admin-blink-context.js.map